import { allowedUserType, eventQuota, isVerifiedByCoreEvent, modulesRequired } from '../rules'

import TheaterEventTemplateInfoContainer from '@/components/events/TheaterEventTemplateInfoContainer.vue'
import TheaterPerformancesContainer from '@/components/events/TheaterPerformancesContainer.vue'
import MailingList from '@/components/organizations/MailingList.vue'
import MembersList from '@/components/organizations/memberships/MembersList.vue'
import MembershipsContainer from '@/components/organizations/memberships/MembershipsContainer.vue'
import ReportsContainer from '@/components/organizations/reports/ReportsContainer.vue'
import SubscriptionsList from '@/components/organizations/subscriptions/SubscriptionsList.vue'
import SubscriptionsPlanContainer from '@/components/organizations/subscriptions/SubscriptionsPlanContainer.vue'
import TheaterOrganizationSidebar from '@/components/shared/sidebars/theater-organization/TheaterOrganizationSidebar.vue'
import {
  theaterOrganizationRouteNames,
  theaterOrganizerRouteNames,
} from '@/routing/routeNames/theaterOrganizerRouterNames'
import CustomSuccessfulPayment from '../../components/accreditations/CustomSuccessfulPayment.vue'
import SuccessfulPayment from '../../components/accreditations/SuccessfulPayment.vue'
import OrganizationCreateContainer from '../../components/organizations/OrganizationCreateContainer.vue'
import OrganizationsListContainer from '../../components/organizations/OrganizationsListContainer.vue'
import OrganizationLiveEventsListContainer from '../../components/organizations/events/OrganizationLiveEventsListContainer.vue'
import OrganizationPastEventsListContainer from '../../components/organizations/events/OrganizationPastEventsListContainer.vue'
import genres from '../../components/organizations/genres-and-tags/genres.vue'
import tags from '../../components/organizations/genres-and-tags/tags.vue'
import PromoCodeInfoContainer from '../../components/organizations/promo-codes/PromoCodeInfoContainer.vue'
import PromoCodesContainer from '../../components/organizations/promo-codes/PromoCodesContainer.vue'
import TicketType from '../../components/organizations/ticket-types/TicketTypeContainer.vue'
import TheaterTicketStatistics from '../../components/stats/theater-ticket-statistic-container.vue'
import TheaterTicketListContainer from '../../components/tickets/TheaterTicketListContainer.vue'
import { mainRouteNames } from '../routeNames/mainRouteNames'
import { getPropsFromParams } from '../utils.routing'
import AccreditationUpdateContainer from './../../components/accreditations/AccreditationUpdateContainer.vue'
import EventRequestsContainer from './../../components/accreditations/EventRequestsContainer.vue'
import TheaterAccreditationsListContainer from './../../components/accreditations/TheaterAccreditationListContainer.vue'
import TheaterInviteAttendeesContainer from './../../components/accreditations/TheaterInviteAttendeeContainer.vue'
import InviteEditContainer from './../../components/accreditations/invite/InviteEditContainer.vue'
import AttendeeFieldsContainer from './../../components/events/AttendeeFieldsContainer.vue'
import EventCategoriesContainer from './../../components/events/EventCategoriesContainer.vue'
import EventCreateContainer from './../../components/events/EventCreateContainer.vue'
import EventUsersContainer from './../../components/events/EventUsersContainer.vue'
import EventsListContainer from './../../components/events/EventsListContainer.vue'
import ImportContainer from './../../components/import-export/ImportContainer.vue'
import Subscribers from './../../components/organizations/mailing-list/subscribers.vue'
import OrganizerSidebar from './../../components/shared/sidebars/organizer/OrganizerSidebar.vue'
import TheaterScannedTicketsContainer from './../../components/stats/theater-scanned-ticket-container.vue'
import TheaterVisitorStatsContainer from './../../components/stats/visitor/theater-visitor-statistic-container.vue'
import InviteContainer from './../../components/user/InviteContainer.vue'
import OrganizerProfileContainer from './../../components/user/OrganizerProfileContainer.vue'
import TrialAccountInviteContainer from './../../components/user/TrialAccountInviteContainer.vue'
import OrganizerFinanceInfo from './../../components/user/finance-info.vue'
import TheaterImportExportContainer from '@/components/import-export/TheaterImportExportContainer.vue'
import TheaterExportContainer from '@/components/import-export/TheaterExportContainer.vue'
import TheaterEmailsListContainer from '@/components/emails/TheaterEmailsListContainer.vue'
import TheaterEmailCreateContainer from '@/components/emails/TheaterEmailCreateContainer.vue'
import TheaterEmailUpdateContainer from '@/components/emails/TheaterEmailUpdateContainer.vue'
import TheaterEmailDetailsContainer from '@/components/emails/TheaterEmailDetailsContainer.vue'
import TheaterFloorPlanOverview from '@/components/stats/theater-floor-plan-overview.vue'
import TheaterDocumentationContainer from '@/components/event-documentation/TheaterDocumentationContainer.vue'
import LegalEntityInvoicesContainer from '@/components/event-documentation/LegalEntityInvoicesContainer.vue'

const theaterDashboardSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/dashboard',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventDashboardTheater,
    component: TheaterTicketStatistics,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Ticket statistics',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/floor-plan-overview',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.theaterFloorPlanOverview,
    component: TheaterFloorPlanOverview,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Floor plan overview',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/stats/visitors',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.visitorStatisticsTheater,
    component: TheaterVisitorStatsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Visitor statistics',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/stats/scanned',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.scannedTicketsTheater,
    component: TheaterScannedTicketsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Scanned tickets',
    },
  },
]

const attendeeListSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/accreditations',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.accreditationsTheater,
    component: TheaterAccreditationsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendee list',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/accreditation/:accreditationId/edit',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.editAccreditationTheater,
    component: AccreditationUpdateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Update Accreditation',
    },
  },
]

const importExportSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/data',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.importExportTheater,
    component: TheaterImportExportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'What do you need?',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/data/import',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.importTheater,
    component: ImportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Import',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/data/export',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.exportTheater,
    component: TheaterExportContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Export',
    },
  },
]

const emailsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/emails',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.emailsTheater,
    component: TheaterEmailsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Emails to attendees',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/emails/new',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.createEmailTheater,
    component: TheaterEmailCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Create email',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/emails/:emailId/details',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.emailDetailsTheater,
    component: TheaterEmailDetailsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Email details',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/emails/:emailId/update',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.updateEmailTheater,
    component: TheaterEmailUpdateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [isVerifiedByCoreEvent()],
      title: 'Update automated email',
    },
  },
]

const inviteAttendeesSidebarRoute = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/invite-attendee',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.inviteAttendeeTheater,
    component: TheaterInviteAttendeesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Invite attendees',
    },
  },
]

const pendingRequestsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/requests',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.requestsTheater,
    component: EventRequestsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendance requests',
    },
  },
]

const editInviteSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/edit-invite',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.editInviteTheater,
    component: InviteEditContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Edit invite information',
    },
  },
]

const ticketsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/tickets',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.ticketsTheater,
    component: TheaterTicketListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Tickets',
    },
  },
]

const eventInfoSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/info',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventInfoTheater,
    component: TheaterEventTemplateInfoContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Event info',
    },
  },
]

const theaterUsersSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/event-workers',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventWorkersTheater,
    component: EventUsersContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'EventWorkers',
    },
  },
]

const theaterPerformance = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/performances',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.theaterPerformance,
    component: TheaterPerformancesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'TheaterPerformance',
    },
  },
]

const documentationSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/documentation',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventDocumentationTheater,
    component: TheaterDocumentationContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Documentation',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/:eventId/legal-entity-invoices',
    name: theaterOrganizerRouteNames.eventLegalEntityInvoicesTheater,
    props: getPropsFromParams,
    component: LegalEntityInvoicesContainer,
    meta: {
      rules: [allowedUserType(['SUPER_ADMIN', 'REGULAR'])],
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
]

const categoriesSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/categories',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.eventCategoriesTheater,
    component: EventCategoriesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      eventRules: [modulesRequired(['categoriesAndZones'])],
      title: 'Categories',
    },
  },
]

const attendeeFieldsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId/attendee-fields',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.attendeeFieldsTheater,
    component: AttendeeFieldsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      title: 'Attendee fields',
    },
  },
]

const theaterOrganizationEventsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/live-events',
    name: theaterOrganizationRouteNames.theaterLiveEvents,
    props: getPropsFromParams,
    component: OrganizationLiveEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Live events',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/past-events',
    name: theaterOrganizationRouteNames.theaterPastEvents,
    props: getPropsFromParams,
    component: OrganizationPastEventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Past events',
    },
  },
]
const theaterOrganizationGenresAndTagsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/genres',
    name: theaterOrganizationRouteNames.theaterOrganizationGenres,
    props: getPropsFromParams,
    component: genres,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Genres',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/tags',
    name: theaterOrganizationRouteNames.theaterOrganizationTags,
    props: getPropsFromParams,
    component: tags,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Tags',
    },
  },
]
const theaterOrganizationSubscriptionsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/subscriptions-plan',
    name: theaterOrganizationRouteNames.theaterOrganizationSubscriptionsPlan,
    props: getPropsFromParams,
    component: SubscriptionsPlanContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscriptions plan',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/subscriptions-list',
    name: theaterOrganizationRouteNames.theaterOrganizationSubscriptionsList,
    props: getPropsFromParams,
    component: SubscriptionsList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscriptions list',
    },
  },
]
const theaterOrganizationMembershipsSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/membership-plan',
    name: theaterOrganizationRouteNames.theaterOrganizationMemberships,
    props: getPropsFromParams,
    component: MembershipsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Memberships',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/members-list',
    name: theaterOrganizationRouteNames.theaterOrganizationMembersList,
    props: getPropsFromParams,
    component: MembersList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Members list',
    },
  },
]

const theaterOrganizationInfoSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/organization-info',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationProfileInfo,
    component: OrganizerProfileContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Organization info',
    },
  },
]

const theaterOrganizationTicketTypeSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/ticket-type',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationTicketType,
    component: TicketType,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Ticket types',
    },
  },
]

const theaterOrganizationMailingListSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/mailing-list',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationMailingList,
    component: MailingList,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Mailing list',
    },
  },
]

const theaterFinanceInfoSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/finance-info',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationFinanceInfo,
    component: OrganizerFinanceInfo,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Finance info',
    },
  },
]

const theaterSubscribersSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/subscribers',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationSubscribers,
    component: Subscribers,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Subscribers',
    },
  },
]

const theaterPromoCodesSidebarRoutes = [
  {
    path: '/theater-organizations/:organizationSlug/promo-codes',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationPromoCodes,
    component: PromoCodesContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Promo codes',
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/promo-codes/:promoCodeId',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationPromoCodeInfo,
    component: PromoCodeInfoContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Promo code',
    },
  },
]

const theaterOrganizationSidebarRoutes = [
  ...theaterOrganizationEventsSidebarRoutes,
  ...theaterOrganizationTicketTypeSidebarRoutes,
  ...theaterOrganizationSubscriptionsSidebarRoutes,
  ...theaterOrganizationMailingListSidebarRoutes,
  ...theaterOrganizationInfoSidebarRoutes,
  ...theaterFinanceInfoSidebarRoutes,
  ...theaterSubscribersSidebarRoutes,
  ...theaterOrganizationGenresAndTagsSidebarRoutes,
  ...theaterPromoCodesSidebarRoutes,
  ...theaterOrganizationMembershipsSidebarRoutes,
]

const theaterOrganizerSidebarRoutes = [
  ...theaterDashboardSidebarRoutes,
  ...theaterPerformance,
  ...attendeeListSidebarRoutes,
  ...documentationSidebarRoutes,
  ...importExportSidebarRoutes,
  ...emailsSidebarRoutes,
  ...inviteAttendeesSidebarRoute,
  ...pendingRequestsSidebarRoutes,
  ...editInviteSidebarRoutes,
  ...ticketsSidebarRoutes,
  ...eventInfoSidebarRoutes,
  ...theaterUsersSidebarRoutes,
  ...categoriesSidebarRoutes,
  ...attendeeFieldsSidebarRoutes,
]

const nonSidebarRoutes = [
  {
    path: '/events',
    name: theaterOrganizerRouteNames.eventsTheater,
    props: getPropsFromParams,
    component: EventsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['EVENT_WORKER'])],
    },
  },
  {
    path: '/',
    name: theaterOrganizerRouteNames.organizationsTheater,
    props: getPropsFromParams,
    component: OrganizationsListContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/theater-organizations/new',
    name: theaterOrganizerRouteNames.createOrganizationTheater,
    component: OrganizationCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/events/new',
    name: theaterOrganizationRouteNames.theaterOrganizationAddEvent,
    props: getPropsFromParams,
    component: EventCreateContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [eventQuota(), allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
  },
  {
    path: '/invite/:inviteToken',
    name: theaterOrganizerRouteNames.inviteTheater,
    component: InviteContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
    props: getPropsFromParams,
  },
  {
    path: '/create-trial-account',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.createTrialAccountTheater,
    component: TrialAccountInviteContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      hideProAccountButton: true,
    },
  },
  {
    path: '/successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.successfulPaymentTheater,
    component: SuccessfulPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/custom-successful-payment/:orderUUID',
    props: getPropsFromParams,
    name: theaterOrganizerRouteNames.customSuccessfulPaymentTheater,
    component: CustomSuccessfulPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/theater-organizations/:organizationSlug/reports',
    props: getPropsFromParams,
    name: theaterOrganizationRouteNames.theaterOrganizationReports,
    component: ReportsContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
      title: 'Reports',
    },
  },
]

export const TheaterOrganizerRoutes = [
  ...nonSidebarRoutes,
  {
    path: '/theater-organizations/:organizationSlug/event/:eventTemplateId',
    redirect: { name: theaterOrganizerRouteNames.eventDashboardTheater },
    name: mainRouteNames.theaterOrganizerSidebar,
    props: getPropsFromParams,
    component: OrganizerSidebar,
    meta: {
      requiresAuthentication: true,
      requiresAuthorization: true,
      redirectIfAuthenticated: false,
    },
    children: theaterOrganizerSidebarRoutes,
  },
  {
    path: '/theater-organizations/:organizationSlug',
    redirect: { name: theaterOrganizationRouteNames.theaterLiveEvents },
    name: mainRouteNames.theaterOrganizationSidebar,
    props: getPropsFromParams,
    component: TheaterOrganizationSidebar,
    meta: {
      requiresAuthentication: true,
      requiresAuthorization: true,
      redirectIfAuthenticated: false,
      rules: [allowedUserType(['REGULAR', 'SUPER_ADMIN'])],
    },
    children: theaterOrganizationSidebarRoutes,
  },
]
